export default "__VITE_ASSET__BbU9ItrW__"